import { render, staticRenderFns } from "./Digitalization.vue?vue&type=template&id=0d901708&"
import script from "./Digitalization.vue?vue&type=script&lang=js&"
export * from "./Digitalization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports